import { render, staticRenderFns } from "./GanchoFinal.vue?vue&type=template&id=c0d85f26&scoped=true"
import script from "./GanchoFinal.vue?vue&type=script&lang=js"
export * from "./GanchoFinal.vue?vue&type=script&lang=js"
import style0 from "./GanchoFinal.vue?vue&type=style&index=0&id=c0d85f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d85f26",
  null
  
)

export default component.exports